import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_DISTRICT = gql`
  query RookiedayDistrict($districtId: Int!) {
    rookiedayDistrict(districtId: $districtId) {
      id
      name
      state
      providerRegisterTime {
        openAt
        closeAt
      }
      scholarRegisterTime {
        openAt
        closeAt
      }
      dates {
        id
        date
        placeName
        placeRoom
        placeStreet
        placeZip
        schools {
          id
          schoolName
        }
      }
    }
  }
`;
